<template>
  <div
    :id="this.id"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    :style="style()"
    class="sitebuilder-element-container"
    element="MultiStepFormComponent"
    @contextmenu.prevent="handler($event)"
    @click="focusElement($event)"
  >
    <delete-confirmation-modal
      ref="discardCaptcha"
      :custom="true"
      :title="$t('discard')"
      :message="$t('ct-remove-recaptcha-confirm')"
      :confirm-message="$t('ct-remove')"
      @confirm="saveReCaptcha('', '')"/>

    <vue-draggable-resizable
      ref="draggableResizable"
      :w="parseInt(internal_config.width)"
      :h="parseInt(internal_config.height)"
      :draggable="false"
      @resizing="onResize"
    >
      <sync-drag :target="this"/>
      <rotate
        :target="this.$refs.draggableResizable"
        :config="this.internal_config"/>
      <options-element-bar
        ref="optionsBar"
        :elem="this"
        name="ct-component-MultiStepFormComponent">
        <img
          v-tooltip="{content:$t('ct-option-set-fields'), class: 'tooltip-custom'}"
          src="static/images/icons/engrenagem.svg"
          class="svg-icon normal-action"
          @click="changeFields"
        >

<!--        <img-->
<!--          v-tooltip="{content:$t('ct-option-socialproof'), class: 'tooltip-custom'}"-->
<!--          src="static/images/icons/social-proof-option.svg"-->
<!--          class="svg-icon normal-action"-->
<!--          @click="openSocialProof">-->
<!--        <img-->
<!--          v-tooltip="{content:$t('ct-option-remove-recaptcha'), class: 'tooltip-custom'}"-->
<!--          v-if="internal_config.recaptchaSiteKey"-->
<!--          class="svg-icon normal-action"-->
<!--          src="static/images/icons/delete.svg"-->
<!--          @click="clearRecaptcha()"-->
<!--        >-->
<!--        <img-->
<!--          v-tooltip="{content:$t('ct-option-set-recaptcha'), class: 'tooltip-custom'}"-->
<!--          v-else-->
<!--          class="svg-icon normal-action"-->
<!--          src="static/images/icons/recaptcha.svg"-->
<!--          @click="openModalRecaptcha()"-->
<!--        >-->
      </options-element-bar>

      <div
        v-show="!this.preview"
        class="divBlock"/>
      <form
        ref="form"
        :class="horizontal ? 'form-simple horizontal-form': 'form-simple'"
        :target="internal_config.target"
        :action="internal_config.action"
        :receiver="internal_config.receiver"
        :subject="internal_config.subject"
        method="post"
      >
        <ul
          id="progressbar"
          ref="progressbar"/>
        <div
          ref="container"
          class="inputs-area"/>
        <div
          v-if="internal_config.recaptchaSiteKey"
          class="recaptcha-container">
          <vue-recaptcha :sitekey="internal_config.recaptchaSiteKey"/>
        </div>
        <div
          :style="{ margin: buttonMargin, display: 'flex', justifyContent: 'center', alignItems: 'center'  }"
          class="place-btn">
          <div
            v-show="showPreviousButton"
            :style="{
              width : buttonPreviousWidth,
              'box-shadow': buttonPreviousBoxShadow,
              border : buttonPreviousBorder,
              'border-radius': buttonPreviousRadius,
              background: buttonPreviousBackground,
            }"
            class="bt-sb bt-sb-previous">
            <div
              :style="{minHeight: buttonPreviousHeight}"
              class="bt-text-area d-flex align-items-center flex-wrap overflow-hidden">
              <a
                :style="textPreviousStyle()"
                class="sb-text button-previous-sb-button"
                @click="previous($event)">{{ internal_config.buttonPrevious.text }}</a>
              <small
                v-if="internal_config.buttonPrevious.subText"
                :style="subTextPreviousStyle()"
                class="sb-sub-text">{{ internal_config.buttonPrevious.subText }}</small>
            </div>
          </div>
          <div
            v-show="showSubmitButton"
            :style="{
              width : buttonWidth,
              'box-shadow': buttonBoxShadow,
              border : buttonBorder,
              'border-radius': buttonRadius,
              background: buttonBackground,
            }"
            class="bt-sb bt-sb-submit">
            <div
              :style="{minHeight: buttonHeight}"
              class="bt-text-area d-flex align-items-center flex-wrap overflow-hidden">
              <a
                :style="textStyle()"
                class="sb-text button-sb-button"
                @click="submit($event)">{{ internal_config.button.text }}</a>
              <small
                v-if="internal_config.button.subText"
                :style="subTextStyle()"
                class="sb-sub-text">{{ internal_config.button.subText }}</small>
            </div>
          </div>
          <div
            v-show="showNextButton"
            :style="{
              width : buttonNextWidth,
              'box-shadow': buttonNextBoxShadow,
              border : buttonNextBorder,
              'border-radius': buttonNextRadius,
              background: buttonNextBackground,
            }"
            class="bt-sb bt-sb-next">
            <div
              :style="{minHeight: buttonNextHeight}"
              class="bt-text-area d-flex align-items-center flex-wrap overflow-hidden">
              <a
                :style="textNextStyle()"
                class="sb-text button-next-sb-button"
                @click="next($event)">{{ internal_config.buttonNext.text }}</a>
              <small
                v-if="internal_config.buttonNext.subText"
                :style="subTextNextStyle()"
                class="sb-sub-text">{{ internal_config.buttonNext.subText }}</small>
            </div>
          </div>
        </div>
      </form>

      <resources ref="resourcesData"/>

    </vue-draggable-resizable>
  </div>
</template>

<script>
import Vue from 'vue';
import Data from './Model';
import Resources from './Resources.vue';

import VueRecaptcha from 'vue-recaptcha';

import CheckFields from '../Fields/CheckFields.vue';
import SelectFields from '../Fields/SelectFields.vue';
import TextFields from '../Fields/Text.vue';
import DateFields from '../Fields/DateFields.vue';
import OptionsElementBar from "../../OptionsElementBar";
import ReCaptcha from "../../../resources/ReCaptcha";

export default {
  name: 'MultiStepComponent',
  components: {
    OptionsElementBar,
    Resources,
    CheckFields,
    SelectFields,
    TextFields,
    DateFields,
    VueRecaptcha,
    ReCaptcha
  },
  mixins: [],
  props: ['config', 'id', 'preview', 'device'],
  data() {
    return Data.data();
  },
  computed: {
    horizontal() {
      return this.internal_config.horizontal;
    },

    buttonWidth() {
      return parseInt(this.internal_config.button.width) / 2 + '%';
    },
    buttonHeight() {
      return parseInt(this.internal_config.button.height) + 'px';
    },
    buttonBorder() {
      return this.internal_config.button.border;
    },
    buttonBoxShadow() {
      return this.internal_config.button.boxShadow;
    },
    buttonRadius() {
      return this.internal_config.button.borderRadius;
    },
    buttonBackground() {
      let bg = this.internal_config.button.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
        bg += ' url("' + this.internal_config.button.backgroundImage + '")';
        bg += ' ' + this.internal_config.button.backgroundPosition;
        bg += ' / ' + this.internal_config.button.backgroundSize;
        bg += ' ' + this.internal_config.button.backgroundRepeat;
        bg += ' ' + this.internal_config.button.backgroundOrigin;
      }

      return bg;
    },
    buttonMargin() {
      const horizontal = this.internal_config.horizontal;
      const margin = this.internal_config.button.margin;

      return horizontal ? `0px 0px 0px ${margin}px` : `${margin}px 0px 0px`;
    },

    buttonNextWidth() {
      return parseInt(this.internal_config.buttonNext.width) / 2 + '%';
    },
    buttonNextHeight() {
      return parseInt(this.internal_config.buttonNext.height) + 'px';
    },
    buttonNextBorder() {
      return this.internal_config.buttonNext.border;
    },
    buttonNextBoxShadow() {
      return this.internal_config.buttonNext.boxShadow;
    },
    buttonNextRadius() {
      return this.internal_config.buttonNext.borderRadius;
    },
    buttonNextBackground() {
      let bg = this.internal_config.buttonNext.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
        bg += ' url("' + this.internal_config.buttonNext.backgroundImage + '")';
        bg += ' ' + this.internal_config.buttonNext.backgroundPosition;
        bg += ' / ' + this.internal_config.buttonNext.backgroundSize;
        bg += ' ' + this.internal_config.buttonNext.backgroundRepeat;
        bg += ' ' + this.internal_config.buttonNext.backgroundOrigin;
      }

      return bg;
    },

    buttonPreviousWidth() {
      return parseInt(this.internal_config.buttonPrevious.width) / 2 + '%';
    },
    buttonPreviousHeight() {
      return parseInt(this.internal_config.buttonPrevious.height) + 'px';
    },
    buttonPreviousBorder() {
      return this.internal_config.buttonPrevious.border;
    },
    buttonPreviousBoxShadow() {
      return this.internal_config.buttonPrevious.boxShadow;
    },
    buttonPreviousRadius() {
      return this.internal_config.buttonPrevious.borderRadius;
    },
    buttonPreviousBackground() {
      let bg = this.internal_config.buttonPrevious.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
        bg += ' url("' + this.internal_config.buttonPrevious.backgroundImage + '")';
        bg += ' ' + this.internal_config.buttonPrevious.backgroundPosition;
        bg += ' / ' + this.internal_config.buttonPrevious.backgroundSize;
        bg += ' ' + this.internal_config.buttonPrevious.backgroundRepeat;
        bg += ' ' + this.internal_config.buttonPrevious.backgroundOrigin;
      }

      return bg;
    },

    showSubmitButton() {
      if (typeof this.internal_config.currentIndex !== undefined &&
        this.internal_config.groups &&
        this.internal_config.currentIndex === (this.internal_config.groups.length - 1)
      )
        return true;
    },
    showPreviousButton() {

      if (this.internal_config.form.showPreviousButton === false)
        return false;


      if (typeof this.internal_config.currentIndex !== undefined &&
        this.internal_config.groups &&
        this.internal_config.currentIndex >= 1
      )
        return true;
    },
    showNextButton() {
      if (typeof this.internal_config.currentIndex !== undefined &&
        this.internal_config.groups &&
        this.internal_config.currentIndex < (this.internal_config.groups.length - 1)
      )
        return true;

    }
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    },
  },

  created() {
    this.internal_config = {...this.props, ...this.$props.config};

    let internal_config = window.mergeRecursive(this.props, this.$props.config);
    this.internal_config = {...internal_config, ...this.internal_config};
  },

  mounted() {

    this.buildIcon();

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      this.$el.classList.add('preview');

      this.$el.addEventListener('mouseover', function () {
        //submit
        document.body.style.setProperty(
          '--button-background-color--hover',
          vm.internal_config.button.backgroundColorHover
        );
        document.body.style.setProperty(
          '--button-text-color--hover',
          vm.internal_config.button.textColorHover
        );
        //next
        document.body.style.setProperty(
          '--button-background-color-next--hover',
          vm.internal_config.buttonNext.backgroundColorHover
        );
        document.body.style.setProperty(
          '--button-text-color-next--hover',
          vm.internal_config.buttonNext.textColorHover
        );
        //previous
        document.body.style.setProperty(
          '--button-background-color-previous--hover',
          vm.internal_config.buttonPrevious.backgroundColorHover
        );
        document.body.style.setProperty(
          '--button-text-color-previous--hover',
          vm.internal_config.buttonPrevious.textColorHover
        );
      });
    }

    this.buildFields(this);
    this.buildProgressBar(this);

    this.inputStyle();
    this.placeholderStyle();

    this.setColumns();

    let objIds = [];
    $('[id]').each(function () {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);

    });
    if (objIds.includes(this.id))
      this.id = Date.now() + parseInt(Math.random() * 10000);


    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$refs.resourcesData.setValuesData(this);

  },

  methods: {
    animation() {
      return true;
    },
    animateField() {
      this.internal_config.fieldAnimated = true;
    },

    verifyRequired() {
      if (this.internal_config.newField.required == 'no') {
        this.$refs.visibilyField.style.display = 'block';
        this.$refs.visibilyFieldOption.style.display = 'block';
      } else {
        this.$refs.visibilyField.style.display = 'none';
        this.$refs.visibilyFieldOption.style.display = 'none';
      }
    },
    setColumns() {

      let container = this.$el.querySelector('.inputs-area');

      if (this.internal_config.columns <= 1) {
        container.classList.remove("row");

        container.querySelectorAll('.form-group').forEach(input => {
          for (let i = 1; i <= 12; i++)
            input.parentElement.classList.remove("col-" + i);

        });

      } else {

        container.classList.add("row");

        container.querySelectorAll('.form-group').forEach(input => {
          for (let i = 1; i <= 12; i++)
            input.parentElement.classList.remove("col-" + i);

          input.parentElement.classList.add(`col-${12 / this.internal_config.columns}`);
        });

      }


    },
    changeFields() {
      this.$root.$emit('openMultiStepFormModal', this.internal_config, 'config', this.save);
    },
    submit(e) {
      e.preventDefault();

      this.$refs.form.submit();
    },
    next(e) {
      e.preventDefault();

      this.internal_config.currentIndex = this.internal_config.currentIndex + 1;
      this.hideGroups();
    },
    previous(e) {
      e.preventDefault();

      this.internal_config.currentIndex = this.internal_config.currentIndex - 1;
      this.hideGroups();
    },
    save(config) {
      this.internal_config = Object.assign({}, this.internal_config, config);
      this.buildFields(this);
      this.buildProgressBar(this);
      $(this.$el).css({zIndex: this.internal_config.zIndex});
      // this.$refs.modal.close();
    },
    buildProgressBar: function (vm) {

      this.$refs.progressbar.innerHTML = '';

      if (vm.internal_config.navBar.type === 'none')
        return;

      vm.internal_config.groups.forEach((group, indexG) => {

        const li = $('<li>')
          .css({
            color: vm.internal_config.navBar.titleTextColor,
            'font-size': vm.internal_config.navBar.titleSize,
            'width': (100 / (vm.internal_config.groups.length)) + '%'
          })
          .addClass('progress-item ' + (vm.internal_config.currentIndex === indexG ? 'active' : ''))
          .text(vm.internal_config.navBar.showTitle ? group.name : '')
          .appendTo(
            $(this.$refs.progressbar)
              .get(0)
          );


        if (vm.internal_config.navBar.type === 'icon') {
          document.body.style.setProperty('--progressbar-li-before-content', 'no-close-quote');
          $('<i>')
            .addClass('mdi ' + group.icon)
            .appendTo(li);
        } else
          document.body.style.setProperty('--progressbar-li-before-content', 'counter(step)');

      });

      document.body.style.setProperty('--progressbar-li-before-font-size', this.internal_config.navBar.size);
      document.body.style.setProperty('--progressbar-li-before-color', this.internal_config.navBar.activeTextColor);
      document.body.style.setProperty('--progressbar-li-before-background', this.internal_config.navBar.backgroundColorActive);
      document.body.style.setProperty('--progressbar-li-before-radius', this.internal_config.navBar.borderRadius);

      document.body.style.setProperty('--progressbar-li-after-background', this.internal_config.navBar.backgroundColorInactive);
      document.body.style.setProperty('--progressbar-li-after-color', this.internal_config.navBar.inactiveTextColor);
    },
    buildFields: function (vm) {
      this.$refs.container.innerHTML = '';

      vm.internal_config.groups.forEach((group, indexG) => {

        const groupRef = vm.createGroupPlace(indexG);

        if (vm.internal_config.form.showTitle)
          vm.createTitleMultiStep(group.name, groupRef);


        if (vm.internal_config.form.showDescription)
          vm.createDescriptionMultiStep(group.description, groupRef);


        group.fields.forEach(field => {

          let identifier = field.field;
          if (typeof identifier === 'undefined')
            identifier = 'text';


          if (identifier === 'textarea') vm.createTextField(field, true, false, groupRef);
          if (identifier === 'text') vm.createTextField(field, false, false, groupRef);
          if (identifier === 'password') vm.createTextField(field, false, true, groupRef);
          if (identifier === 'select') vm.createDropDown(field, false, groupRef);
          if (identifier === 'multiselect') vm.createDropDown(field, true, groupRef);
          if (identifier === 'dropdown') vm.createDropDown(field, false, groupRef);
          if (identifier === 'datetime') vm.createDateTime(field, true, groupRef);
          if (identifier === 'date') vm.createDateTime(field, false, groupRef);
          if (identifier === 'checkbox') vm.createCheckField(field, 'checkbox', groupRef);
          if (identifier === 'radio') vm.createCheckField(field, 'radio', groupRef);
        });
      });

      this.inputStyle();
      this.$loading.hide();
      this.hideGroups();
    },
    onResize: function (x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);


      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    edit(e) {
      e.preventDefault();
      this.internal_config.src = prompt('src', this.internal_config.src);
    },

    textStyle() {
      let sizeMobile = typeof this.internal_config.button.textStyle.sizeMobile !== 'undefined' && this.internal_config.button.textStyle.sizeMobile ?
        this.internal_config.button.textStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.button.textStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.button.textStyle.size};
                 text-align: ${this.internal_config.button.textStyle.align};
                 font-weight: ${this.internal_config.button.textStyle.weight};
                 font-style: ${this.internal_config.button.textStyle.style};
                 color: ${this.internal_config.button.textStyle.color}`;
    },

    subTextStyle() {
      let sizeMobile = typeof this.internal_config.button.subTextStyle.sizeMobile !== 'undefined' && this.internal_config.button.subTextStyle.sizeMobile ?
        this.internal_config.button.subTextStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.button.subTextStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.button.subTextStyle.size};
                 text-align: ${this.internal_config.button.subTextStyle.align};
                 font-weight: ${this.internal_config.button.subTextStyle.weight};
                 font-style: ${this.internal_config.button.subTextStyle.style};
                 color: ${this.internal_config.button.subTextStyle.color}`;
    },

    textNextStyle() {
      let sizeMobile = typeof this.internal_config.buttonNext.textStyle.sizeMobile !== 'undefined' && this.internal_config.buttonNext.textStyle.sizeMobile ?
        this.internal_config.buttonNext.textStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.buttonNext.textStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.buttonNext.textStyle.size};
                 text-align: ${this.internal_config.buttonNext.textStyle.align};
                 font-weight: ${this.internal_config.buttonNext.textStyle.weight};
                 font-style: ${this.internal_config.buttonNext.textStyle.style};
                 color: ${this.internal_config.buttonNext.textStyle.color}`;
    },

    subTextNextStyle() {
      let sizeMobile = typeof this.internal_config.buttonNext.subTextStyle.sizeMobile !== 'undefined' && this.internal_config.buttonNext.subTextStyle.sizeMobile ?
        this.internal_config.buttonNext.subTextStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.buttonNext.subTextStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.buttonNext.subTextStyle.size};
                 text-align: ${this.internal_config.buttonNext.subTextStyle.align};
                 font-weight: ${this.internal_config.buttonNext.subTextStyle.weight};
                 font-style: ${this.internal_config.buttonNext.subTextStyle.style};
                 color: ${this.internal_config.buttonNext.subTextStyle.color}`;
    },

    textPreviousStyle() {
      let sizeMobile = typeof this.internal_config.buttonPrevious.textStyle.sizeMobile !== 'undefined' && this.internal_config.buttonPrevious.textStyle.sizeMobile ?
        this.internal_config.buttonPrevious.textStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.buttonPrevious.textStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.buttonPrevious.textStyle.size};
                 text-align: ${this.internal_config.buttonPrevious.textStyle.align};
                 font-weight: ${this.internal_config.buttonPrevious.textStyle.weight};
                 font-style: ${this.internal_config.buttonPrevious.textStyle.style};
                 color: ${this.internal_config.buttonPrevious.textStyle.color}`;
    },

    subTextPreviousStyle() {
      let sizeMobile = typeof this.internal_config.buttonPrevious.subTextStyle.sizeMobile !== 'undefined' && this.internal_config.buttonPrevious.subTextStyle.sizeMobile ?
        this.internal_config.buttonPrevious.subTextStyle.sizeMobile : false;
      return `font-family:  ${this.internal_config.buttonPrevious.subTextStyle.family};
                 font-size: ${(this.device === 'mobile') ? sizeMobile : this.internal_config.buttonPrevious.subTextStyle.size};
                 text-align: ${this.internal_config.buttonPrevious.subTextStyle.align};
                 font-weight: ${this.internal_config.buttonPrevious.subTextStyle.weight};
                 font-style: ${this.internal_config.buttonPrevious.subTextStyle.style};
                 color: ${this.internal_config.buttonPrevious.subTextStyle.color}`;
    },

    buildIconInsideButton: function (type, apply) {
      if (this.internal_config[type].icon !== '') {
        if (this.internal_config[type].iconPosition === 'left') {
          $('<i>')
            .addClass('mdi ' + this.internal_config[type].icon)
            .prependTo(
              $(this.$el)
                .find('.' + apply + '-sb-button')
                .get(0)
            );
        }
        if (this.internal_config[type].iconPosition === 'right') {
          $('<i>')
            .addClass('mdi ' + this.internal_config[type].icon)
            .appendTo(
              $(this.$el)
                .find('.' + apply + '-sb-button')
                .get(0)
            );
        }
      }
    },
    buildIcon: function () {
      $(this.$el)
        .find('i')
        .detach();

      this.buildIconInsideButton('button', 'button');
      this.buildIconInsideButton('buttonNext', 'button-next');
      this.buildIconInsideButton('buttonPrevious', 'button-previous');
    },
    build(config) {
      this.internal_config = config;

      this.internal_config.currentIndex = 0;
    },
    style() {
      return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler: function (e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    createCheckField(field, type, placeAt) {
      let ComponentClass = Vue.extend(CheckFields);
      let instance = new ComponentClass({
        propsData: {
          type: type,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          label: field.label,
          options: field.options,
          selected: [],
          data: field
        }
      });
      instance.$mount();
      $(placeAt).append(instance.$el);
    },
    createDropDown(field, multiple, placeAt) {
      let ComponentClass = Vue.extend(SelectFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          options: field.options,
          selected: field.default_value,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          data: field,
          multiple: multiple
        }
      });
      instance.$mount();
      $(placeAt).append(instance.$el);
    },
    createDateTime(field, useCurrent, placeAt) {
      let ComponentClass = Vue.extend(DateFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          data: field,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          value: new Date().toString(),
          type: useCurrent ? 'datetime' : 'date',
          icon: field.icon,
        }
      });
      instance.$mount();
      $(placeAt).append(instance.$el);
    },
    createTextField(field, area, pass, placeAt) {
      let ComponentClass = Vue.extend(TextFields);
      let instance = new ComponentClass({
        propsData: {
          label: field.label,
          value: field.default_value,
          pass: pass,
          color: this.internal_config.inputStyle.color,
          showLabel: this.internal_config.showLabel,
          showPlaceholder: this.internal_config.showPlaceholder,
          icon: field.icon,
          data: field,
          area: area
        }
      });
      instance.$mount();
      $(placeAt).append(instance.$el);
    },
    createGroupPlace(groupIndex) {
      return $('<div>')
        .addClass('step-group multi-group-' + groupIndex)
        .appendTo(
          $(this.$refs.container)
            .get(0)
        );
    },
    createTitleMultiStep(name, groupPlace) {
      let sizeMobile = typeof this.internal_config.titleFormStyle.sizeMobile !== 'undefined' && this.internal_config.titleFormStyle.sizeMobile ?
        this.internal_config.titleFormStyle.sizeMobile : false;
      $('<div>')
        .text(name)
        .css({
          'margin-bottom': '5px',
          'font-family': this.internal_config.titleFormStyle.family,
          'font-size': (this.device === 'mobile') ? sizeMobile : this.internal_config.titleFormStyle.size,
          'text-align': this.internal_config.titleFormStyle.align,
          'font-weight': this.internal_config.titleFormStyle.weight,
          'font-style': this.internal_config.titleFormStyle.style,
          'color': this.internal_config.titleFormStyle.color
        })
        .addClass('title-multi-step')
        .appendTo(
          groupPlace
        );

    },
    createDescriptionMultiStep(description, groupPlace) {
      let sizeMobile = typeof this.internal_config.descriptionFormStyle.sizeMobile !== 'undefined' && this.internal_config.descriptionFormStyle.sizeMobile ?
        this.internal_config.descriptionFormStyle.sizeMobile : false;
      $('<div>')
        .text(description)
        .css({
          'margin-bottom': '5px',
          'font-family': this.internal_config.descriptionFormStyle.family,
          'font-size': (this.device === 'mobile') ? sizeMobile : this.internal_config.descriptionFormStyle.size,
          'text-align': this.internal_config.descriptionFormStyle.align,
          'font-weight': this.internal_config.descriptionFormStyle.weight,
          'font-style': this.internal_config.descriptionFormStyle.style,
          'color': this.internal_config.descriptionFormStyle.color
        })
        .addClass('description-multi-step')
        .appendTo(
          groupPlace
        );
    },
    inputStyle() {
      let vm = this;

      let elements = this.$refs.container.getElementsByClassName(
        'form-control'
      );
      [].forEach.call(elements, function (el) {
        el.style.backgroundColor = vm.internal_config.inputBgColor;
        el.style.border = vm.internal_config.inputBorder;

        if (el.tagName === 'TEXTAREA' && vm.internal_config.textareaHeight) {
          el.style.height = vm.internal_config.textareaHeight;
          el.classList.add('form-control-textarea-has-height');
        } else
          el.style.height = vm.internal_config.inputHeight;

        el.style.borderRadius = vm.internal_config.inputRadius;

        el.style.fontFamily = vm.internal_config.inputStyle.family;
        el.style.fontSize = vm.internal_config.inputStyle.size;
        el.style.textAlign = vm.internal_config.inputStyle.align;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.fontStyle = vm.internal_config.inputStyle.style;
        el.style.color = vm.internal_config.inputStyle.color;
      });
      vm.$el.style.color = vm.internal_config.labelStyle;
    },

    hideGroups() {
      this.internal_config.groups.forEach((group, indexG) => {
        if (indexG !== this.internal_config.currentIndex) {
          const elements = this.$refs.container.getElementsByClassName(
            'multi-group-' + indexG
          );
          elements[0].style.display = 'none';
        }

        const progressItems = this.$refs.progressbar.getElementsByClassName('progress-item');

        progressItems.forEach(el => {
          el.classList.remove('active');
        });

      });
      this.internal_config.groups.forEach((group, indexG) => {
        if (indexG === this.internal_config.currentIndex) {
          const elements = this.$refs.container.getElementsByClassName(
            'multi-group-' + indexG
          );
          elements[0].style.display = 'block';
        }

        const progressItems = this.$refs.progressbar.getElementsByClassName('progress-item');

        progressItems.forEach((el, i) => {
          if (i <= this.internal_config.currentIndex)
            el.classList.add('active');
        });

      });
    },
    placeholderStyle() {
      const elements = this.$refs.container.getElementsByClassName(
        'form-control'
      );

      for (let element of elements)
        element.style.setProperty('--placeholder-color', this.internal_config.placeholderColor || '#5c5c5c');

    },
    changePosition(index, newIndex) {
      if (newIndex >= this.internal_config.fields.length || newIndex < 0)
        return;


      this.animateField();
      this.internal_config.fields.splice(
        newIndex,
        0,
        this.internal_config.fields.splice(index, 1)[0]
      );
    },
    saveReCaptcha(siteKey, secretKey) {
      this.internal_config.recaptchaSiteKey = siteKey;
      this.internal_config.recaptchaSecretKey = secretKey;
      this.$snotify.success(this.$t('ct-saved'));
    },

    clearRecaptcha() {
      this.$refs.discardCaptcha.open();
    },

    openSocialProof() {
      this.$root.$emit('openFormConfigSocialProofConfigModal', this.internal_config, 'simple-form', 'fields', (config) => {
        this.internal_config = Object.assign({}, this.internal_config, config);
      });
    },

    openModalRecaptcha() {
      this.$root.$emit('showReCaptcha', this.internal_config.recaptchaSiteKey, this.internal_config.recaptchaSecretKey, this.saveReCaptcha);
    },

  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sitebuilder-element-container .vdr,
.vdr,
.bt-sb,
form.form-simple {
  height: auto !important;
}

.preview .bt-sb.bt-sb-submit:hover {
  cursor: pointer;
  background-color: var(--button-background-color--hover) !important;

  * {
    color: var(--button-text-color--hover) !important;
  }
}

.preview .bt-sb.bt-sb-next:hover {
  cursor: pointer;
  background-color: var(--button-background-color-next--hover) !important;

  * {
    color: var(--button-text-color-next--hover) !important;
  }
}

.preview .bt-sb.bt-sb-previous:hover {
  cursor: pointer;
  background-color: var(--button-background-color-previous--hover) !important;

  * {
    color: var(--button-text-color-previous--hover) !important;
  }
}

.place-btn {
  text-align: center;

  .bt-sb {
    max-width: 49%;
    display: inline-block;
  }

  .sb-text,
  .sb-sub-text {
    width: 100%;
  }
}

.bt-text-area {
  display: block;
}

[data-device="tablet"] .bt-text-area,
[data-device="mobile"] .bt-text-area {
  width: auto !important;
}
</style>
<style lang="scss">

label {
  max-width: 100%;
  word-wrap: break-word
}

input.form-control, textarea.form-control {
  &::placeholder {
    color: var(--placeholder-color);
  }
}

.list-item {
  display: block;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 5px;
  margin-top: 2px;
  cursor: pointer;
}

.list-item.selected {
  border: 1px solid blue;
}

/*progressbar*/
#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  /*CSS counters to number the steps*/
  counter-reset: step;
}

#progressbar li {
  list-style-type: none;
  text-transform: uppercase;
  float: left;
  position: relative;
  letter-spacing: 1px;
  text-align: center;

  .mdi {
    position: absolute;
    top: 0;
    left: calc(50% - 8px);
    font-size: calc(var(--progressbar-li-before-font-size) + 6px);
    color: var(--progressbar-li-after-color);
  }
}

#progressbar li:before {
  content: var(--progressbar-li-before-content);
  counter-increment: step;
  width: 26px;
  height: 26px;
  line-height: 26px;
  display: block;
  margin: 0 auto 10px auto;
  font-size: var(--progressbar-li-before-font-size);
  color: var(--progressbar-li-after-color);
  background: var(--progressbar-li-after-background);
  border-radius: var(--progressbar-li-before-radius);
}

/*progressbar connectors*/
#progressbar li:after {
  content: '';
  width: 100%;
  height: 2px;
  background: var(--progressbar-li-after-background);
  color: var(--progressbar-li-after-color);
  position: absolute;
  left: -50%;
  top: 9px;
  z-index: -1; /*put it behind the numbers*/
}

#progressbar li:first-child:after {
  /*connector not needed before the first step*/
  content: none;
}

/*marking active/completed steps blue*/
/*The number of the step and the connector before it = blue*/
#progressbar li.active:before, #progressbar li.active:after {
  background: var(--progressbar-li-before-background);
  color: var(--progressbar-li-before-color);
}

#progressbar li.active .mdi {
  color: var(--progressbar-li-before-color);
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/MultiStepForm/MultiStepForm.vue